import React from 'react';
import styled from 'styled-components';
import { Button, OutlineButton } from '../styles/Hero.styles';
import { openBooking, openTasks } from '../HomePage/Hero';

const PlansSection = styled.section`
  padding: 5rem 0;
  background: #f9fafb;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1rem;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const SectionDescription = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #666;
  max-width: 800px;
  margin: 0 auto 4rem;
  line-height: 1.6;
`;

const PlansContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const PlanCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

const PlanHeader = styled.div`
  display: flex;
  font-family: 'Poppins', sans-serif;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  background: #eff6ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`;

const PlanHeaderText = styled.div`
  flex: 1;
`;

const PlanTitle = styled.h3`
  font-size: 1.5rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: #000;
`;

const PlanSubtitle = styled.p`
  font-size: 0.95rem;
  color: #1d4ed8;
  font-weight: 500;
  margin: 0;
`;

const PlanDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  color: #333;
  font-size: 0.95rem;

  &:before {
    content: '';
    width: 20px;
    height: 20px;
    background: #eff6ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%231d4ed8'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M5 13l4 4L19 7'/%3E%3C/svg%3E");
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export default function Plans() {
  return (
    <PlansSection id="plans">
      <div className="container">
        <SectionTitle>Two ways to keep your home spotless</SectionTitle>
        <SectionDescription>
          Whether you need ongoing housekeeping plans or individual task
          completion, we make it simple to maintain your home exactly how you
          want it.
        </SectionDescription>

        <PlansContainer>
          {/* Housekeeping Plans Card */}
          <PlanCard>
            <PlanHeader>
              <IconWrapper>📅</IconWrapper>
              <PlanHeaderText>
                <PlanTitle>Housekeeping Plans</PlanTitle>
                <PlanSubtitle>Consistent & Reliable</PlanSubtitle>
              </PlanHeaderText>
            </PlanHeader>

            <PlanDescription>
              Regular housekeeping with your trusted professional. Perfect for
              maintaining a consistently clean home without the hassle.
            </PlanDescription>

            <FeatureList>
              <FeatureItem>Same trusted professional when possible</FeatureItem>
              <FeatureItem>Transparent pricing by home size</FeatureItem>
              <FeatureItem>Flexible scheduling around your routine</FeatureItem>
            </FeatureList>

            <Button
              onClick={() => openBooking(undefined, 'residents-plan')}
              style={{
                width: '100%',
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                fontWeight: 500,
              }}
              // @ts-ignore
              hoverBackground="#0093ED"
            >
              Get my housekeeping plan →
            </Button>
          </PlanCard>

          {/* On-Demand Tasks Card */}
          <PlanCard>
            <PlanHeader>
              <IconWrapper>⚡</IconWrapper>
              <PlanHeaderText>
                <PlanTitle>On-Demand Tasks</PlanTitle>
                <PlanSubtitle>Quick & Flexible</PlanSubtitle>
              </PlanHeaderText>
            </PlanHeader>

            <PlanDescription>
              Individual cleaning tasks completed exactly when you need them.
              Perfect for specific projects or one-time cleaning needs.
            </PlanDescription>

            <FeatureList>
              <FeatureItem>Pay only for what you need</FeatureItem>
              <FeatureItem>Same-day availability</FeatureItem>
              <FeatureItem>Quick 15-60 minute windows</FeatureItem>
            </FeatureList>

            <OutlineButton
              onClick={() => openTasks(undefined, 'residents-task')}
              style={{
                width: '100%',
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                fontWeight: 500,
              }}
            >
              Book one-time task →
            </OutlineButton>
          </PlanCard>
        </PlansContainer>
      </div>
    </PlansSection>
  );
}
